<app-product-list [products]="products" [isIt]="false"> </app-product-list>
